import { BaseModel } from "@/models/base.model.ts"
import type { Moment } from "moment"
import type { IRentalMaterialization } from "@/interfaces/api/rental-materialization.interface.ts"

export abstract class RentalMaterialization extends BaseModel implements IRentalMaterialization {
  periodStart: Moment
  periodEnd: Moment
  quantity: string
  unitPricePerDay: string
  netDayQuantity: number
  sequenceNumber: number

  // Annotated fields
  instructionReference: string
  orderReference: string
  projectName: string
  projectExecutorFirstName: string
  projectExecutorLastName: string
  projectExecutorFullName: string
  projectExecutorKnownBusinessEntityName: string

  constructor(rentalMaterialization: IRentalMaterialization) {
    super(rentalMaterialization)

    this.periodStart = rentalMaterialization.periodStart
    this.periodEnd = rentalMaterialization.periodEnd
    this.quantity = rentalMaterialization.quantity
    this.unitPricePerDay = rentalMaterialization.unitPricePerDay
    this.netDayQuantity = rentalMaterialization.netDayQuantity
    this.sequenceNumber = rentalMaterialization.sequenceNumber
    this.instructionReference = rentalMaterialization.instructionReference
    this.orderReference = rentalMaterialization.orderReference
    this.projectName = rentalMaterialization.projectName
    this.projectExecutorFirstName = rentalMaterialization.projectExecutorFirstName
    this.projectExecutorLastName = rentalMaterialization.projectExecutorLastName
    this.projectExecutorFullName = rentalMaterialization.projectExecutorFullName
    this.projectExecutorKnownBusinessEntityName =
      rentalMaterialization.projectExecutorKnownBusinessEntityName
  }

  public getTotalAmount() {
    return this.getUnitDays() * parseFloat(this.unitPricePerDay)
  }

  public getUnitDays(): number {
    return parseFloat(this.quantity) * this.netDayQuantity
  }

  public getProjectDisplayText() {
    return `${this.projectName} | ${this.projectExecutorFirstName} | ${this.projectExecutorLastName} | ${this.projectExecutorKnownBusinessEntityName}`
  }
}
